import "./novItem.css";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import React, { useEffect, useState } from "react";
import { Badge, Button } from "react-bootstrap";
import { getJsonFromStorage } from "../../../../utils/getJsonFromStorage";

function NovItem() {
  const { itemId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [itemData, setItemData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const showPrev = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const showNext = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) =>
      prev < itemData.grupo_photos.length - 1 ? prev + 1 : prev,
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const loadItemData = async () => {
      setIsLoading(true);
      try {
        const fileName = location.pathname.includes("/noticias")
          ? "noticias.json"
          : "testimonios.json";
        const data = await getJsonFromStorage(fileName);
        if (!data) throw new Error("Failed to fetch data");

        const selectedItem = data.find((item) => item.id.toString() === itemId);
        setItemData(selectedItem || null);
      } catch (error) {
        console.error("Error loading item data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    loadItemData();
  }, [location.pathname, itemId]);

  if (isLoading)
    return (
      <div className="loading-placeholder">
        <p>Procesando...</p>
      </div>
    );
  if (!itemData)
    return (
      <div className="loading-placeholder">
        <p>Procesando... Intente más tarde</p>
      </div>
    );

  return (
    <div className="news">
      <div className="news-content">
        <h2>{itemData.title}</h2>
        <Badge className="date" bg="secondary">
          {itemData.date}
        </Badge>
        <hr />
        <div className="news-image">
          <img
            src={
              itemData.image ||
              "https://cdn-redmaestra-endpoint.azureedge.net/static/media/default.png"
            }
            alt={itemData.title}
          />
        </div>
        <ReactMarkdown>{itemData.body}</ReactMarkdown>
        {itemData.link && (
          <Button
            href={itemData.link}
            target="_blank"
            variant="outline-primary"
            className="bl"
            style={{ marginBottom: "10px" }}
          >
            Ingresa Aquí
          </Button>
        )}
      </div>
      {itemData.grupo_photos && itemData.grupo_photos.length > 0 && (
        <div className="gallery-section">
          <h5>Galería</h5>
          <div className="gallery-grid">
            {itemData.grupo_photos.map((photo, index) => (
              <img
                key={index}
                src={photo.image}
                alt={`Foto ${index + 1}`}
                className="gallery-photo"
                onClick={() => openLightbox(index)}
                style={{ cursor: "pointer" }}
              />
            ))}
          </div>
        </div>
      )}
      <button onClick={() => navigate(-1)} className="btn btn-primary bl">
        Volver
      </button>
      {lightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <img
            src={itemData.grupo_photos[currentImageIndex].image}
            alt={`Foto ampliada ${currentImageIndex + 1}`}
            className="lightbox-image"
          />
          {currentImageIndex > 0 && (
            <button className="lightbox-prev" onClick={showPrev}>
              ‹
            </button>
          )}
          {currentImageIndex < itemData.grupo_photos.length - 1 && (
            <button className="lightbox-next" onClick={showNext}>
              ›
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default NovItem;
